import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AcquisitionService } from '../../acquisition.service';
import { CommonService } from '../../../../services/common';

@Component({
  selector: 'app-khasra-details',
  templateUrl: './khasra-details.component.html',
  styleUrl: './khasra-details.component.scss'
})
export class KhasraDetailsComponent implements OnInit, OnChanges {
  @Input() khasra: any;
  @Output() khasraClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() farmerClicked: EventEmitter<any> = new EventEmitter<any>();

  currentKhasraData: any;
  currentKhasraSourceData: any;

  otherkhasraofCurrentKhata: any;
  totalAreaofOtherKhasra: any;

  showPartnerModal: boolean = false;
  showFarmerAnshChart: boolean = false
  farmerAnshChartDataOptions: any
  farmerAnshChartDataOptions1: any

  chartSeriesData: any[] = []
  chartSeriesLabels: any[] = []
  FarmersList: any

  constructor(public commonService: CommonService, private acquisitionService: AcquisitionService) {
  }

  ngOnInit(): void {
    // Initialization logic can go here
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getKhasrasDetails(this.khasra?.id);
  }


  /**
   * Fetches khasra details based on the current khasra data
   * It retrieves other khasras of the current khata and calculates the total area of these khasras.
   */
  getKhasrasDetails(khasraId: any) {
    this.acquisitionService.filterKhasra(khasraId).subscribe((res: any) => {
      if (res.length > 0) {
        this.currentKhasraData = res;
        if (Array.isArray(this.currentKhasraData) && this.currentKhasraData.length > 0) {
          this.currentKhasraData = this.currentKhasraData[0];
          this.getOtherKhasrasOfCurrentKhata();
          // this.chartSeriesData = this.commonService.getDistinctKeyValueFromArray(this.currentKhasraData?.owners, "area")

          //#region CHART DATA 
          //get data series (Ansh of each farmer)

          //reset existing data
          this.chartSeriesData = []
          this.chartSeriesLabels = []

          //Get List of farmer
          this.currentKhasraData?.owners.forEach((owners: any) => {
            this.chartSeriesData.push(owners?.area)
            this.chartSeriesLabels.push(owners.firstName + ' ' + owners.lastName)
          });
          //#endregion
        }
      }
    });
  }

  /**
   * Fetches other khasras of the current khata
   * It filters khasras based on the khata ID of the current khasra data
   * and calculates the total area of these khasras.
   */
  getOtherKhasrasOfCurrentKhata() {
    if (this.currentKhasraData?.landKhata?.id) {
      this.acquisitionService.filterKhasra(null, null, null, this.currentKhasraData?.landKhata?.id).subscribe((res: any) => {
        if (res.length > 0) {
          //we need to filter out the current khasra from the list of other khasras
          this.otherkhasraofCurrentKhata = res.filter((khasra: any) => { return khasra.id !== this.currentKhasraData.id; });
          this.totalAreaofOtherKhasra = this.calculateTotalAreaOfOtherKhasras();
        }
      });
    }
  }

  calculateTotalAreaOfOtherKhasras(): number {
    var total = 0;
    if (this.otherkhasraofCurrentKhata || this.otherkhasraofCurrentKhata.length >= 0) {
      total = this.otherkhasraofCurrentKhata?.reduce((sum: any, khasra: any) => {
        return sum + (typeof khasra?.area === 'number' ? khasra?.area : 0);
      }, 0);
    }
    return parseFloat(total?.toFixed(2));
  }


  prepareFarmerAnshGraphData() {
    var unit = this.currentKhasraData?.unitOfMeasure?.name;

    this.farmerAnshChartDataOptions = {
      series: this.chartSeriesData,
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: this.chartSeriesLabels,
      tooltip: {
        y: {
          formatter: function (val: number, opts: any) {
            const label = opts?.w?.globals?.labels?.[opts.seriesIndex] || '';
            return `${label} — ${val} - ${unit}`;
          }
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            show: true,
            position: 'bottom'
          }
        }
      }]
    };


    this.farmerAnshChartDataOptions1 = {
      series: [{
        name: 'Product1',
        data: [40, 10, 55, 40, 10, 15, 20]
      },
      {
        name: 'Product2',
        data: [40, 32, 25, 95, 45, 62]
      },
      {
        name: 'Product3',
        data: [30, 50, 80, 41, 37, 85]
      },
      {
        name: 'Product4',
        data: [20, 25, 30, 49, 55, 28]
      }],
      chart: {
        height: 350,
        type: 'bubble',
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'gradient',
      },
      title: {
        text: '3D Bubble Chart'
      },
      xaxis: {
        tickAmount: 12,
        type: 'datetime',
        labels: {
          rotate: 0,
        }
      },
      yaxis: {
        max: 70
      },
      theme: {
        palette: 'palette2'
      }
    };
  }



  /**
   * Opens the partner modal with the current khasra data
   * @param currentKhasraData The data of the khasra to be displayed in the modal
   */
  openPartnerModal(currentKhasraData: any) {
    this.showPartnerModal = true;
    this.currentKhasraSourceData = currentKhasraData;
  }


  openFarmerModal(currentFarmerData: any) {
    this.farmerClicked.emit(currentFarmerData);
  }

  openKhasraModal(currentKhasra: any) {
    this.khasraClicked.emit({ khasra: currentKhasra });
  }

  showHideFarmerAnshGraph(showGraphs: boolean) {
    if (showGraphs)
      this.prepareFarmerAnshGraphData()

    this.showFarmerAnshChart = showGraphs
  }
}
